import { useEffect } from 'react'

export interface ISelectedBank {
    saderat: boolean
    parsian: boolean
}

interface IGateway {
    is_default: boolean
    is_active: boolean
    is_in_mobile_visible: boolean
    terminal_type: string
    unique_code: string
    img_url?: string
}

interface IData {
    gateways?: IGateway[]
}

/** Legacy hook kept for backward compat with pages not yet migrated. */
export const useIsDefaultGateway = (
    data: IData | undefined,
    setIsSelected: React.Dispatch<React.SetStateAction<ISelectedBank>>
) => {
    useEffect(() => {
        if (data && data.gateways) {
            const parsianDefault = data.gateways[0]?.is_default || false
            const saderatDefault = data.gateways[1]?.is_default || false
            setIsSelected({ parsian: parsianDefault, saderat: saderatDefault })
        } else {
            setIsSelected({ parsian: false, saderat: false })
        }
    }, [data, setIsSelected])
}

/** Returns gateways that should be shown: Hamyan terminal, active, mobile-visible.
 *  Sorted with is_default=true first so the default gateway renders in the primary
 *  (rightmost) position in RTL layouts. */
export const getActiveGateways = (data: IData | undefined): IGateway[] => {
    const filtered = data?.gateways?.filter(
        (g) => g.terminal_type === 'htrm' && g.is_active && g.is_in_mobile_visible
    ) ?? []
    return [...filtered].sort((a, b) => Number(b.is_default) - Number(a.is_default))
}

/** Sets selectedCode to the default (or first) active gateway's unique_code. */
export const useActiveGatewayCode = (
    data: IData | undefined,
    setCode: React.Dispatch<React.SetStateAction<string | null>>
) => {
    useEffect(() => {
        if (data?.gateways) {
            const active = getActiveGateways(data)
            const def = active.find((g) => g.is_default) ?? active[0] ?? null
            setCode(def?.unique_code ?? null)
        }
    }, [data])
}
